import { API_END_POINT, API_METHOD } from '../utils/constants'
import { apiRequest } from './apiWrapper'

export async function fetchMenuItem() {
    const response = await apiRequest({
        method: API_METHOD.Get,
        url: API_END_POINT.menuItems

        //hardcoded for now
        // url:'http://103.114.153.168:30565/api/bottom_menu/'
    })
    return response
}

export async function fetchSidebarMenu() {
    const response = await apiRequest({
        method: API_METHOD.Get,
        url: API_END_POINT.sidebarMenu
    })
    return response
}
